import React, { FC } from 'react'
import polaroidStyles from '../Polaroid.module.scss'
import classNames from 'classnames'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import { LocaleCurrency } from 'components/FormatPrice'
import useQA from 'hooks/useQA'

type PriceStatusRowProps = {
  isSold: boolean
  isReserved: boolean
  isUnavailable: boolean
  hasOpenEditions: boolean
  showPrintsFromInPrice?: boolean
  minPrintPrice: number
  listPrice: number
}

const PriceStatusRow: FC<PriceStatusRowProps> = ({
  isSold,
  isReserved,
  isUnavailable,
  hasOpenEditions,
  showPrintsFromInPrice,
  minPrintPrice,
  listPrice,
}) => {
  const { testId } = useQA()

  if (isReserved) {
    return (
      <div className={polaroidStyles.availabilityStatus}>
        <span>RESERVED</span>
      </div>
    )
  }

  if (isSold && !hasOpenEditions) {
    return (
      <div className={polaroidStyles.availabilityStatus}>
        <span>SOLD</span>
      </div>
    )
  }

  if (isUnavailable && !hasOpenEditions) {
    return (
      <div className={polaroidStyles.outlinedChip}>
        <span>NOT AVAILABLE</span>
      </div>
    )
  }

  if (minPrintPrice && (showPrintsFromInPrice || ((isSold || isUnavailable) && hasOpenEditions))) {
    return (
      <h6 className={classNames(polaroidStyles.priceInTitle)} data-type='prints-price'>
        Prints From <LocaleCurrency price={convertFromCentsToDollars(minPrintPrice)} />
      </h6>
    )
  }

  return (
    <h6 className={classNames(polaroidStyles.priceInTitle)} {...testId('price')}>
      <LocaleCurrency price={convertFromCentsToDollars(listPrice)} />
    </h6>
  )
}

export default PriceStatusRow
